import React, { useState, useEffect } from 'react'
import { useSelector } from '~/store/hooks'

import Select, { components } from 'react-select'
import isMobile from 'ismobilejs'

const CustomSelect = ({
  options,
  classes,
  classesMobile,
  onChange,
  onChangeMobile,
  hasReset = false,
  type = false,
  customDefaultValue,
}) => {
  let [isMobileSelect, setIsMobileSelect] = useState(false)

  const projectsStatus = useSelector((state) => state.projectsStatus)
  const projectsRegion = useSelector((state) => state.projectsRegion)

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <svg
            className={`react-select__icon iocn-purple ${props.selectProps.menuIsOpen && 'is-open'}`}
            width="24"
            height="24"
            viewBox="0 0 18 18"
          >
            <path d="M4.721 6.398a.689.689 0 01.957-.033l.057.056L8.948 9.97l3.325-3.556a.69.69 0 01.955-.062l.059.055c.263.274.283.71.058 1.009l-.052.062-3.843 4.11a.69.69 0 01-.97.05l-.057-.058-3.724-4.11a.788.788 0 01.022-1.071z" />
          </svg>
        </components.DropdownIndicator>
      )
    )
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsMobileSelect(isMobile(window.navigator).any)
    }
  }, [])

  const renderCustomSelect = () => {
    let value, defaultValue

    if (hasReset) {
      const stateVariable = type === 'status' ? projectsStatus : projectsRegion
      value = stateVariable === null ? options[0] : stateVariable
    } else {
      defaultValue = customDefaultValue ?? options[0]
    }

    return (
      <>
        {hasReset ? (
          <Select
            components={{ DropdownIndicator }}
            options={options}
            onChange={onChange}
            value={value}
            className={`react-select-container ${classes}`}
            classNamePrefix="react-select"
            isSearchable={false}
          />
        ) : (
          <Select
            components={{ DropdownIndicator }}
            options={options}
            onChange={onChange}
            defaultValue={defaultValue}
            className={`react-select-container ${classes}`}
            classNamePrefix="react-select"
            isSearchable={false}
          />
        )}
      </>
    )
  }

  return (
    <>
      {isMobileSelect && onChangeMobile ? (
        <select
          className={`mobile-select ${classesMobile ?? ''}`}
          onBlur={(e) => onChangeMobile(e)}
          data-type={type}
        >
          {options.map((option, i) => {
            return (
              <option key={i} value={option.value}>
                {option.label}
              </option>
            )
          })}
        </select>
      ) : (
        renderCustomSelect()
      )}
    </>
  )
}

export default CustomSelect
